import BaseEntityNew from 'client/components/core/BaseEntity/BaseEntityNew'
import usePresentPage, { selectors } from 'client/hooks/usePresentPage'
import { usePage } from 'client/store'
import { isWebsitePageType } from 'client/store/page/pageSelectors'
import { EntityProps } from 'client/types'
import { CommonPriceElement } from 'common/components/entities/price-element'
import { PriceElementInterface } from 'common/types/entities/price-element-interface'
import React from 'react'
import { useTypedTranslation } from 'src/shared/i18next/hooks/use-typed-translation'
import { usePricePlans } from './hooks/usePricePlans'

export const PriceElement = ({
  entity,
  isMoveDownAllowed,
  isMoveUpAllowed,
}: EntityProps<PriceElementInterface>) => {
  const locale = usePresentPage(selectors.getPageLocale)
  const { i18n } = useTypedTranslation()
  const fixedT = i18n.getFixedT(locale)
  const { pricePlans, isFetching } = usePricePlans({ locale })
  const isWebsitePage = usePage(isWebsitePageType)

  return (
    <BaseEntityNew
      entity={entity}
      isMoveUpAllowed={isMoveUpAllowed}
      isMoveDownAllowed={isMoveDownAllowed}
    >
      <CommonPriceElement
        locale={locale}
        pricePlans={pricePlans}
        openPopup={() => {
          //
        }}
        t={fixedT}
        isLoading={isFetching}
        isWebsitePage={isWebsitePage}
      />
    </BaseEntityNew>
  )
}
